"use client";

import type { ComponentType } from "react";
import type { SelectionIndicatorStyle } from "./form-types";

import { cn } from "@homeinstead/ui";
import { SelectedMultiSelectCheckmark } from "./SelectedMultiSelectCheckmark";
import { UncheckedSelectionIndicator } from "./UncheckedSelectionIndicator";

type MultiSelectIndicatorConfig = {
  SelectedIndicator: ComponentType;
  UnselectedIndicator: ComponentType;
  slotClass: string;
};

const MULTI_SELECT_INDICATORS: Record<
  Exclude<SelectionIndicatorStyle, "none">,
  MultiSelectIndicatorConfig
> = {
  checkmark: {
    SelectedIndicator: SelectedMultiSelectCheckmark,
    slotClass: "w-6",
    UnselectedIndicator: UncheckedSelectionIndicator,
  },
};

function MultiSelectIndicatorSlot({
  isSelected,
  style,
}: {
  isSelected: boolean;
  style: SelectionIndicatorStyle | null | undefined;
}) {
  const configuration =
    style && style !== "none"
      ? MULTI_SELECT_INDICATORS[
          style as Exclude<SelectionIndicatorStyle, "none">
        ]
      : undefined;

  if (!configuration) {
    return null;
  }

  const { SelectedIndicator, UnselectedIndicator, slotClass } = configuration;

  return (
    <div className={cn("shrink-0", slotClass)}>
      {isSelected ? <SelectedIndicator /> : <UnselectedIndicator />}
    </div>
  );
}

export { MULTI_SELECT_INDICATORS, MultiSelectIndicatorSlot };
